import React, { useState, useEffect } from "react";
import { getBackendUrl } from "../config";

export default function TwoFactorSetupModal({ onClose, onSuccess }) {
  const [secret, setSecret] = useState("");
  const [uri, setUri] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchSetup();
  }, []);

  const fetchSetup = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${getBackendUrl()}/api/auth/2fa/setup`, {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      setLoading(false);
      if (res.ok && data.status === "success") {
        setSecret(data.secret);
        setUri(data.otpauth_uri);
      } else {
        setError(data.message || "Impossible d'initialiser le 2FA.");
      }
    } catch (err) {
      setLoading(false);
      setError("Erreur réseau.");
    }
  };

  const handleEnable = async (e) => {
    e.preventDefault();
    if (!code || code.trim().length !== 6) {
      setError("Veuillez saisir un code à 6 chiffres.");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      const res = await fetch(`${getBackendUrl()}/api/auth/2fa/enable`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json();
      setSubmitting(false);

      if (res.ok && data.status === "success") {
        onSuccess && onSuccess();
        onClose();
      } else {
        setError(data.message || "Code invalide. Vérifiez l'heure de votre téléphone.");
      }
    } catch (err) {
      setSubmitting(false);
      setError("Erreur de connexion.");
    }
  };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.85)", backdropFilter: "blur(8px)",
      zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center",
      padding: "20px"
    }}>
      <div style={{
        background: "#12131C", border: "1px solid #2A2D3E", borderRadius: "16px",
        maxWidth: "460px", width: "100%", padding: "30px", boxShadow: "0 20px 50px rgba(0,0,0,0.8)",
        color: "#fff", fontFamily: "Inter, system-ui, sans-serif"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
          <h3 style={{ margin: 0, fontSize: "1.2rem", color: "#00ff94" }}>🔐 Configuration 2FA (TOTP)</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#888", fontSize: "1.5rem", cursor: "pointer" }}>×</button>
        </div>

        {loading ? (
          <div style={{ padding: "30px", textAlign: "center", color: "#aaa" }}>Chargement du secret 2FA...</div>
        ) : (
          <div>
            <p style={{ color: "#aaa", fontSize: "0.88rem", marginBottom: "15px", lineHeight: "1.4" }}>
              Scannez ou saisissez la clé ci-dessous dans votre application d'authentification (Google Authenticator, Authy, Bitwarden, etc.) :
            </p>

            <div style={{ background: "#1A1C29", border: "1px solid #33374A", borderRadius: "8px", padding: "12px", textAlign: "center", marginBottom: "20px" }}>
              <div style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px" }}>CLÉ SECRÈTE DE SECOURS</div>
              <code style={{ fontSize: "1.1rem", color: "#00ff94", letterSpacing: "2px", fontWeight: "bold" }}>{secret}</code>
            </div>

            {error && (
              <div style={{ background: "rgba(255,50,50,0.15)", border: "1px solid #ff3232", borderRadius: "8px", padding: "10px", color: "#ff8888", fontSize: "0.85rem", marginBottom: "15px" }}>
                {error}
              </div>
            )}

            <form onSubmit={handleEnable}>
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "0.85rem", color: "#ccc", marginBottom: "8px" }}>
                  Entrez le code à 6 chiffres généré par l'application :
                </label>
                <input
                  type="text"
                  maxLength={6}
                  required
                  placeholder="123456"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  style={{
                    width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #00ff94",
                    borderRadius: "8px", color: "#00ff94", fontSize: "1.2rem", textAlign: "center",
                    letterSpacing: "4px", fontWeight: "bold", boxSizing: "border-box"
                  }}
                />
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    flex: 1, padding: "12px", background: "transparent", border: "1px solid #444",
                    borderRadius: "8px", color: "#ccc", cursor: "pointer"
                  }}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    flex: 1, padding: "12px", background: "linear-gradient(135deg, #00ff94, #00b8ff)",
                    border: "none", borderRadius: "8px", color: "#000", fontWeight: "bold", cursor: "pointer",
                    opacity: submitting ? 0.6 : 1
                  }}
                >
                  {submitting ? "Activation..." : "Activer le 2FA"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
